import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useRef } from "react";
import { useScrollEffect } from "@/hooks/useScrollEffect";
import { useFeaturesEnabled } from "@/contexts/cdpConfig";
import { AdContainer } from "./AdContainer";
import { AdSlotIds } from "@/shared/types";
import { useShowAds } from "../hooks/useShowAds";
export const MediumRectangles = () => {
    const adRectangle1 = useRef(null);
    const adRectangle2 = useRef(null);
    const scrollableDiv = useRef(null);
    const { openedContactForm } = useFeaturesEnabled();
    useScrollEffect({
        stickyElementRef: adRectangle1,
        scrollableElementRef: adRectangle2,
        containerRef: scrollableDiv,
        initialOffset: openedContactForm ? "500%" : "100%",
    });
    const { showSection } = useShowAds();
    return (_jsx(_Fragment, { children: showSection([
            AdSlotIds.AD_MEDIUM_RECTANGLE_1,
            AdSlotIds.AD_MEDIUM_RECTANGLE_2,
        ]) && (_jsx(Box, { id: "scrollable-div", ref: scrollableDiv, display: "flex", justifyContent: "center", width: "100%", unsafe_className: "HideOnPrint", children: _jsxs(Box, { children: [_jsx(Box, { position: "sticky", 
                        // position="relative"
                        top: 0, ref: adRectangle1, zIndex: "zIndex.1", children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_MEDIUM_RECTANGLE_1, display: {
                                "breakpoint.base": "none",
                                "breakpoint.lg": "flex",
                            }, showLabel: true }) }), _jsx(Box, { ref: adRectangle2, zIndex: "zIndex.2", position: "relative", transform: `translateY(100%)`, children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_MEDIUM_RECTANGLE_2, display: {
                                "breakpoint.base": "none",
                                "breakpoint.lg": "flex",
                            }, showLabel: true }) })] }) })) }));
};
